import React, { useEffect, useState } from "react";
import { Modal, Form, Button, Select } from "antd";
import { svg } from "../../../../Assets/svg";
import { useAppDispatch } from "../../../../store";
import { updateQuotationAPI, getQuotationDetailsAPI } from "../quotationApis";
import { setQuotationDetails } from "../quotationSlice";
import { renderFormLabel } from "../../../../Components/Components";
import { getLeadTimeOptions } from "../../../../helpers/utils";

interface ChangeEstimatedLeadTimeModalProps {
  open: boolean;
  onClose: () => void;
  quote_id: string;
  current_lead_time_days?: number;
  refreshData?: () => void;
}

export const ChangeEstimatedLeadTimeModal: React.FC<
  ChangeEstimatedLeadTimeModalProps
> = ({
  open,
  onClose,
  quote_id,
  current_lead_time_days,
  refreshData,
}) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  const currentWeeks =
    current_lead_time_days != null
      ? Number((current_lead_time_days / 7).toFixed(1))
      : undefined;

  useEffect(() => {
    if (open) {
      form.setFieldsValue({
        estimated_lead_time_weeks: currentWeeks,
      });
    }
  }, [open, currentWeeks, form]);

  const onFinish = (values: any) => {
    setSaving(true);
    const selectedWeeks = Number(values.estimated_lead_time_weeks);
    const leadTimeDays = selectedWeeks * 7;

    dispatch(
      updateQuotationAPI({
        payload: {
          quote_id: quote_id,
          estimated_lead_time: leadTimeDays,
        },
        onSuccess: (data: any) => {
          if (data) {
            dispatch(setQuotationDetails(data));
          } else {
            dispatch(
              getQuotationDetailsAPI({
                quote_id: quote_id,
                onSuccess: (response: any) => {
                  dispatch(setQuotationDetails(response));
                },
              }),
            );
          }
          setSaving(false);
          onClose();
          refreshData?.();
        },
        onError: () => {
          setSaving(false);
        },
      }),
    );
  };

  return (
    <Modal
      centered
      open={open}
      onCancel={onClose}
      footer={null}
      closeIcon={svg?.closeIcon}
      width="36rem"
      className="commonModalClass"
      destroyOnClose={true}
      title={
        <div className="text-center fs-4 fw-bolder lh-m">
          Change Estimated Lead Time?
        </div>
      }
    >
      <p className="text-center text-secondary mb-4">
        Please update the estimated lead time for this quotation.
      </p>

      <Form
        layout="vertical"
        form={form}
        className="page-form"
        onFinish={onFinish}
        initialValues={{ estimated_lead_time_weeks: currentWeeks }}
      >
        <Form.Item
          label={renderFormLabel("Estimated Lead Time", true)}
          name="estimated_lead_time_weeks"
          rules={[
            {
              required: true,
              message: "Please select estimated lead time",
            },
          ]}
          required={false}
        >
          <Select
            placeholder="Select estimated lead time"
            className="w-100"
            suffixIcon={svg?.selectDownArrow}
          >
            {getLeadTimeOptions().map((opt) => (
              <Select.Option key={opt.value} value={opt.value}>
                {opt.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <div className="d-flex justify-content-center gap-3 mt-4">
          <Button
            htmlType="button"
            className="btn btn-lg btn-outline-secondary h-auto px-5"
            onClick={onClose}
            disabled={saving}
          >
            CLOSE
          </Button>
          <Button
            htmlType="submit"
            className="btn btn-lg btn-primary h-auto px-5"
            type="primary"
            loading={saving}
          >
            SAVE
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default ChangeEstimatedLeadTimeModal;
